var map = {
	"./allegro.png": "e36a",
	"./apilo.png": "b10f",
	"./baselinker.png": "94c0",
	"./erecruiter.png": "f048",
	"./pipedrive.png": "9c4d",
	"./prestashop.png": "ecc8",
	"./shoper.png": "185b",
	"./shopify.png": "a966",
	"./traffit.png": "2941",
	"./woocommerce.png": "9618",
	"./zapier.png": "586b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b72a";